import { Transform } from "class-transformer";
import { toEuros } from "@/utils/numberUtils";

export class PayrollCalendarViewWarningDto {
  conceptKey: string;

  label: string;

  reason: "missing" | "extra" | "mismatch" | "total-mismatch";

  actual?: Readonly<{
    quantity: number;
    quantityScale: number;
    quantityUnit?: string | null;
    unitPrice: number;
    amount: number;
  }> | null;

  expected?: Readonly<{
    quantity: number;
    quantityScale: number;
    quantityUnit?: string | null;
    unitPrice: number;
    amount: number;
  }> | null;

  diff?: Readonly<{
    quantity: number;
    unitPrice: number;
    amount: number;
  }> | null;

  @Transform(({ obj }) => (obj?.diff?.amount != null ? toEuros(obj.diff.amount) : null))
  diffAmountEuros?: number | null;

  @Transform(({ obj }) => (obj?.actual?.amount != null ? toEuros(obj.actual.amount) : null))
  actualAmountEuros?: number | null;

  @Transform(({ obj }) => (obj?.expected?.amount != null ? toEuros(obj.expected.amount) : null))
  expectedAmountEuros?: number | null;
}
